import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { ISocialProofNode, PartialNode } from "../type";

const createSocialProofNode = (
  data?: PartialNode<ISocialProofNode>
): ISocialProofNode => {
  const id = shortUUID.generate();
  return {
    id,
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [
        {
          type: "social_proof_script_info",
          name: "소셜프루프 스크립트 정보",
        },
        {
          type: "social_proof_event_type",
          name: "소셜 프루프",
        },
        {
          type: "text_content",
          name: "텍스트 내용",
        },
        {
          type: "social_proof_format",
          name: "소셜프루프 형식",
        },
        {
          type: "social_proof_condition",
          name: "소셜프루프 조회시점",
        },
        {
          type: "social_proof_target",
          name: "소셜프루프 노출조건",
        },
        {
          type: "social_proof_adjustment",
          name: "소셜프루프 보정값",
        },
        {
          type: "text_color",
          name: "텍스트 색상",
        },
        {
          type: "text_background_color",
          name: "텍스트 배경색상",
        },
      ],
    },
    reactions: [],
    position: createPosition(data?.position),

    // 노드트리 등에서 보이는 이름
    name: "소셜프루프",

    content: `{{socialProof.count}} 명의 고객님이 상품을 조회했어요!`,

    width: { value: 100, unit: "%" },
    alignHorizontal: "LEFT",

    fills: [],
    backgrounds: [],

    locked: false,

    paragraphIndent: {
      value: 0,
      unit: "em",
    },

    lineHeight: {
      value: 1.3,
      unit: "",
    },

    paragraphSpacing: {
      value: 0,
      unit: "em",
    },

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    textAlignHorizontal: "CENTER",
    textAlignVertical: "CENTER",
    // TODO: 현재 기본값이 HEIGHT일 뿐, 세로 자동 조정은 height 속성 여부에 의해 결정됨. WIDTH_AND_HEIGHT일 때에는 가로 자동 조정됨.
    textAutoResize: "HEIGHT",

    fontSize: {
      value: 16,
      unit: "px",
    },

    visible: true,

    effects: [],
    boxShadowEffects: [],
    fontName: { style: "normal", family: "InterRegular-ascii" },

    padding: {
      top: {
        value: 10,
        unit: "px",
      },
      bottom: {
        value: 10,
        unit: "px",
      },
      left: {
        value: 0,
        unit: "px",
      },
      right: {
        value: 0,
        unit: "px",
      },
    },

    // 기본값은 고정형 + 반복 없음
    socialProof: {
      type: "PAGEVIEW",
      period: {
        value: 7,
        unit: "DAY",
      },
      target: {
        type: "eventCountThreshold",
        value: 5,
      },

      defaultValue: "xxx",
      adjustment: 0,
    },
    dataAlias: `${id}`,

    // 인자값
    ...data,
    // 필수값

    type: "SOCIAL_PROOF",
  };
};

export default createSocialProofNode;
